var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380.37,
    height: 115.434,
    viewBox: "0 0 380.37 115.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.748,15.712c35.037,0,64.584,29.771,73.748,70.441H0C9.164,45.482,38.71,15.7,73.748,15.7",
    transform: "translate(232.875 2.84)",
    fill: "#bfe3e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.948,25.56c35.037,0,64.584,29.782,73.748,70.453H197.2c9.164-40.67,38.71-70.453,73.748-70.453",
    transform: "translate(-197.2 4.624)",
    fill: "#bfe3e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.607,0c50.047,0,92.252,42.536,105.349,100.625H89.27C102.354,42.536,144.56,0,194.607,0",
    transform: "translate(-25.005)",
    fill: "#bfe3e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.374,66.41c18.41,0,33.927,15.647,38.734,37.01H36.64c4.806-21.363,20.335-37.01,38.734-37.01",
    transform: "translate(222.994 12.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.864,66.41c18.41,0,33.927,15.647,38.734,37.01H126.13c4.806-21.363,20.335-37.01,38.734-37.01",
    transform: "translate(27.825 12.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.755,52.98c26.287,0,48.453,22.343,55.337,52.857H69.43C76.3,75.323,98.48,52.98,124.767,52.98",
    transform: "translate(118.287 9.584)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightClouds);
export default __webpack_public_path__ + "static/media/right-clouds.676af2a72e6f5fba61e5e3cae516fcd0.svg";
export { ForwardRef as ReactComponent };